import { z } from 'zod';

export const CHRONIC_ILLNESSES = [
  'ACNE',
  'ACROMEGALIE',
  'ADENOME_HYPOPHYSAIRE',
  'ADENOMYOSE',
  'ALBINISME_OCULO_CUTANE',
  'ALGIES_DU_TRIJUMEAU',
  'ALGIE_VASCULAIRE_DE_LA_FACE',
  'ALLERGIE',
  'AMYLOSE',
  'ANEMIE_DE_BIERMER',
  'ANEMIE_HEMOLYTIQUE_AUTO_IMMUNE',
  'ANGOR_ANGINE_DE_POITRINE',
  'ANTECEDENT_AIT',
  'ANTECEDENT_AVC',
  'ANTECEDENT_PHLEBITE_EMBOLIE_PULMONAIRE',
  'ANTECEDENT_INFARCTUS_DU_MYOCARDE',
  'APLASIE_MEDULLAIRE',
  'APNEE_DU_SOMMEIL',
  'ARTERITE_STENOSE_CAROTIDIENNE',
  'ARTHROPATHIES_MICROCRISTALLINES',
  'ARTHROSE',
  'ARYTHMIE_CARDIAQUE_ACFA',
  'ASTHME',
  'AUTISME',
  'AUTRE_CANCER',
  'AUTRE_HYPERTHYROIDIE',
  'AUTRE_MALADIE_CARDIAQUE_VASCULAIRE',
  'AUTRE_MALADIE_DE_LA_PEAU',
  'AUTRE_MALADIE_DES_YEUX',
  'AUTRE_MALADIE_DU_FOIE',
  'AUTRE_MALADIE_DU_SANG',
  'AUTRE_MALADIE_DU_SYSTEME_DIGESTIF',
  'AUTRE_MALADIE_ENDOCRINIENNE',
  'AUTRE_MALADIE_INFECTIEUSE_CHRONIQUE',
  'AUTRE_MALADIE_NEUROLOGIQUE',
  'AUTRE_MALADIE_ORL_RESPIRATOIRE',
  'AUTRE_MALADIE_PSYCHIATRIQUE',
  'AUTRE_MALADIE_RENALE_URINAIRE_GENITALE',
  'AUTRE_MALADIE_RHUMATOLOGIQUE',
  'AUTRE_MALADIE_SYSTEMIQUE',
  'AUTRES_DEMENCES',
  'AUTRES_HEMOLYSES_CONSTITUTIONNELLES',
  'AUTRES_LYMPHOMES',
  'AUTRES_SYNDROMES_PARKINSONIENS',
  'BRONCHITE_CHRONIQUE_BPCO',
  'CANCER_PEAU_CARCINOME_BASO_CELLULAIRE',
  'CANCER_PEAU_CARCINOME_SPINOCELLULAIRE',
  'CANCER_PROSTATE',
  'CANCER_THYROIDE',
  'CANCER_VESICULE_BILIAIRE',
  'CANCER_VESSIE',
  'CANCER_ENDOMETRE_UTERUS',
  'CANCER_ESTOMAC',
  'CANCER_OESOPHAGE',
  'CANCER_OVAIRE',
  'CANCER_OS',
  'CANCER_TESTICULES',
  'CANCER_CERVEAU',
  'CANCER_COL_UTERUS',
  'CANCER_COLON',
  'CANCER_FOIE',
  'CANCER_PANCREAS',
  'CANCER_POUMON_BRONCHES_PLEVRE',
  'CANCER_RECTUM',
  'CANCER_REIN',
  'CANCER_SEIN',
  'CANCER_ORL',
  'CARDIOPATHIE_CONGENITALE',
  'CATARACTE',
  'CEPHALEES_CHRONIQUES',
  'CERVICALGIE_DORSALGIE_CHRONIQUE',
  'CHIKUNGUNYA',
  'CHOLANGITE_SCLEROSANTE_PRIMITIVE',
  'COLON_IRRITABLE',
  'COVID_19_AIGUE',
  'COVID_19_SYMPTOMES_PERSISTANTS',
  'CRYOGLOBULINEMIE',
  'CYSTITES_RECIDIVANTES',
  'DECOLLEMENT_RETINE',
  'DEFICIT_FACTEUR_COAGULATION',
  'DEFICIT_IMMUNITAIRE',
  'DEGENERESCENCE_MACULAIRE_DMLA',
  'DEMENCE_VASCULAIRE',
  'DEPRESSION',
  'DERMATITE_SEBORRHEIQUE',
  'DERMATOSE_BULLEUSE_CHRONIQUE',
  'DIABETE',
  'DIABETE_INSIPIDE',
  'DILATATION_DES_BRONCHES',
  'DIVERTICULES',
  'DREPANOCYTOSE',
  'DYSHYDROSE',
  'DYSPLASIE_FIBREUSE_OS',
  'DYSTROPHIE_MYOTONIQUE',
  'ECZEMA',
  'ENDOCARDITE',
  'ENDOMETRIOSE',
  'EPIDERMOLYSE_BULLEUSE',
  'EPILEPSIE',
  'EPINE_CALCANEENNE',
  'FIBROME_UTERIN',
  'FIBROMYALGIE',
  'FIEVRE_MEDITERRANEENNE_FAMILIALE',
  'GLAUCOME_CHRONIQUE',
  'HEMOCHROMATOSE',
  'HEMOPHILIE',
  'HEPATITE_B',
  'HEPATITE_C',
  'HEPATITE_CIRRHOSE_ALCOOLIQUE',
  'HEPATITE_CIRRHOSE_AUTO_IMMUNE',
  'HEPATITE_CIRRHOSE_INFECTIEUSE',
  'HEPATITE_CIRRHOSE_METABOLIQUE',
  'HERPES',
  'HYPERALDOSTERONISME_PRIMAIRE',
  'HYPERCHOLESTEROLEMIE_HYPERTRIGLYCERIDEMIE',
  'HYPERPROLACTINEMIE',
  'HYPERSENSIBILITE_CHIMIQUE_MULTIPLE',
  'HYPERTENSION_ARTERIELLE',
  'HYPERTENSION_ARTERIELLE_PULMONAIRE',
  'HYPERTROPHIE_BENIGNE_PROSTATE',
  'HYPOPARATHYROIDIE_CHRONIQUE',
  'HYPOTHYROIDIE',
  'HYSTIOCYTOSE',
  'INCONTINENCE_URINAIRE',
  'INFECTION_OSTEO_ARTICULAIRE',
  'INFECTION_VIH_SIDA',
  'INSUFFISANCE_CARDIAQUE',
  'INSUFFISANCE_PANCREATIQUE',
  'INSUFFISANCE_RENALE_CHRONIQUE',
  'INSUFFISANCE_VEINEUSE_CHRONIQUE',
  'KYSTE_OVARIEN_SOPK',
  'KYSTES_DE_TARLOV',
  'LEPTOSPIROSE',
  'LEUCEMIE_AIGUE',
  'LEUCEMIE_LYMPHOIDE_CHRONIQUE',
  'LEUCEMIE_MYELOIDE_CHRONIQUE',
  'LICHEN_PLAN',
  'LITHIASE_URINAIRE_CHRONIQUE',
  'LOMBALGIE_CHRONIQUE',
  'LUPUS',
  'LYMPHOEDEME',
  'LYMPHOME_FOLLICULAIRE',
  'LYMPHOME_NON_HODGKINIEN',
  'MALADIE_CORPS_DE_LEWY',
  'MALADIE_COELIAQUE',
  'MALADIE_ADDISON',
  'MALADIE_ALZHEIMER',
  'MALADIE_BASEDOW',
  'MALADIE_BEHCET',
  'MALADIE_BERGER',
  'MALADIE_BUERGER',
  'MALADIE_CACCHI_RICCI',
  'MALADIE_CAROLI',
  'MALADIE_CHARCOT_MARIE_TOOTH',
  'MALADIE_CHURG_STRAUSS',
  'MALADIE_CROHN',
  'MALADIE_CROUZON',
  'MALADIE_DUPUYTREN',
  'MALADIE_GILBERT',
  'MALADIE_HORTON',
  'MALADIE_KAWASAKI',
  'MALADIE_LYME',
  'MALADIE_PAGET',
  'MALADIE_PARKINSON',
  'MALADIE_RAYNAUD',
  'MALADIE_RENDU_OSLER',
  'MALADIE_STILL_ADULTE',
  'MALADIE_STRUMPELL_LORRAIN',
  'MALADIE_TAKAYASU',
  'MALADIE_VERNEUIL',
  'MALADIE_VON_HIPPEL_LINDAU',
  'MALADIE_WEGENER',
  'MALADIE_WILLEBRAND',
  'MALADIE_LYMPHOME_HODGKIN',
  'MALFORMATION_ARNOLD_CHIARI',
  'MALFORMATIONS_ARTERIOVEINEUSES_CEREBRALES',
  'MASTOCYTOSE',
  'MELANOME',
  'MENINGIOME',
  'MICROANGIOPATHIE_THROMBOTIQUE',
  'MUCOVISCIDOSE',
  'MYASTHENIE',
  'MYELOME',
  'MYOPATHIE_ACQUISE',
  'MYOPATHIE_GENETIQUE',
  'NARCOLEPSIE',
  'NEUROBLASTOME',
  'NEUROFIBROMATOSE_TYPE_1',
  'NEUROFIBROMATOSE_TYPE_2',
  'NEUROFIBROMATOSE_TYPE_3',
  'NEUROPATHIE_PERIPHERIQUE',
  'NEVRALGIE_ARNOLD',
  'NEVROME_MORTON',
  'OBESITE',
  'OSTEOPOROSE_OSTEOPENIE',
  'OTOSPONGIOSE',
  'PELADE',
  'PERIARTERITE_NOUEUSE',
  'PHEOCHROMOCYTOME',
  'PNEUMOPATHIE_INTERSTITIELLE',
  'POLYANGEITE_MICROSCOPIQUE',
  'POLYARTHRITE_RHUMATOIDE',
  'POLYKYSTOSE_RENALE',
  'POLYPES_COLIQUES',
  'POLYPOSE_NASO_SINUSIENNES',
  'POLYRADICULONEVRITE_CHRONIQUE',
  'PORPHYRIES',
  'PRATIQUES_ADDICTIVES',
  'PROLACTINOME',
  'PSORIASIS',
  'PSYCHOSE_CHRONIQUE',
  'PURPURA_RHUMATOIDE',
  'PURPURA_THROMBOPENIQUE_IMMUNOLOGIQUE',
  'RECTOCOLITE_HEMORRAGIQUE',
  'REFLUX_GASTRO_OESOPHAGIEN',
  'RETINITE_PIGMENTAIRE',
  'RETINOPATHIE',
  'RHINITE_CHRONIQUE',
  'RHUMATISME_PSORIASIQUE',
  'ROSACEE',
  'SARCOIDOSE',
  'SCLERITE_EPISCLERITE',
  'SCLERODERMIE',
  'SCLEROSE_EN_PLAQUE',
  'SCLEROSE_LATERALE_AMYOTROPHIQUE',
  'SCOLIOSE',
  'SINUSITE_CHRONIQUE',
  'SPINA_BIFIDA',
  'SPONDYLOARTHRITE_AXIALE',
  'STEATOSE_HEPATIQUE_NASH',
  'SYNDROME_COCKETT',
  'SYNDROME_COGAN',
  'SYNDROME_CUSHING',
  'SYNDROME_DUNBAR',
  'SYNDROME_FATIGUE_CHRONIQUE',
  'SYNDROME_GOODPASTURE',
  'SYNDROME_GOUJEROT_SJOGREN',
  'SYNDROME_GUILLAIN_BARRE',
  'SYNDROME_EHLERS_DANLOS',
  'SYNDROME_KLINEFELTER',
  'SYNDROME_QUEUE_DE_CHEVAL',
  'SYNDROME_MARFAN',
  'SYNDROME_MAZABRAUD',
  'SYNDROME_NUTCRACKER',
  'SYNDROME_RETT',
  'SYNDROME_ROMANO_WARD',
  'SYNDROME_ANTIPHOSPHOLIPIDES',
  'SYNDROME_SILVER_RUSSELL',
  'SYNDROME_JAMBES_SANS_REPOS',
  'SYNDROME_STRESS_POST_TRAUMATIQUE',
  'SYNDROME_TREACHER_COLLINS',
  'SYNDROME_TURNER',
  'SYNDROME_WILKIE',
  'SYNDROME_WOLFF_PARKINSON_WHITE',
  'SYNDROME_DOULOUREUX_REGIONAL_COMPLEXE',
  'SYNDROME_MYELODYSPLASIQUE',
  'SYNDROME_MYELOPROLIFERATIF',
  'SYNDROMES_CANALAIRES',
  'SYRINGOMYELIE',
  'TENDINITES_CHRONIQUES',
  'THYROIDITE_HASHIMOTO',
  'TROUBLE_BIPOLAIRE',
  'TROUBLE_CONDUCTION',
  'TROUBLE_FERTILITE',
  'TROUBLE_PERSONNALITE',
  'TROUBLE_VISION',
  'TROUBLE_COMPORTEMENT_ALIMENTAIRE',
  'TROUBLE_DEFICIT_ATTENTION_HYPERACTIVITE',
  'TROUBLE_ERECTILE',
  'TROUBLES_ANXIEUX',
  'TROUBLES_AUDITION',
  'TROUBLES_RYTHME_CARDIAQUE',
  'TROUBLES_SOMMEIL',
  'TROUBLES_OBSESSIONNELS_COMPULSIFS',
  'TROUBLE_STOMATOLOGIQUE_MAXILLOFACIAL',
  'TUBERCULOSE',
  'ULCERE_JAMBE',
  'ULCERE_GASTRO_DUODENAL',
  'URTICAIRE',
  'UVEITE',
  'VALVULOPATHIE',
  'VASCULARITE_CRYOGLOBULINEMIQUE',
  'VASCULARITE_URTICARIENNE_HYPOCOMPLEMENTEMIQUE',
  'VERTIGES',
  'VITILIGO',
  'ZONA',
] as const;

export const PredefinedChronicIllnessSchema = z.object({
  type: z.literal('predefined'),
  value: z.enum(CHRONIC_ILLNESSES),
});

export const CustomChronicIllnessSchema = z.object({
  type: z.literal('custom'),
  value: z.string(),
});

export const ChronicIllnessSchema = z.discriminatedUnion('type', [
  PredefinedChronicIllnessSchema,
  CustomChronicIllnessSchema,
]);

export type PredefinedChronicIllness = (typeof CHRONIC_ILLNESSES)[number];
export type ChronicIllness = z.infer<typeof ChronicIllnessSchema>;

export const createPredefined = (
  value: PredefinedChronicIllness,
): ChronicIllness => ({
  type: 'predefined',
  value,
});

export const createCustom = (value: string): ChronicIllness => ({
  type: 'custom',
  value: normalizeCustomValue(value),
});

export const normalizeCustomValue = (value: string): string => {
  return value
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map((word, index) =>
      index === 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase(),
    )
    .join(' ');
};

export const isEqual = (illness1: ChronicIllness, illness2: ChronicIllness) => {
  return illness1.type === illness2.type && illness1.value === illness2.value;
};

export const getKey = (illness: ChronicIllness) => {
  return illness.type === 'custom'
    ? `custom-${illness.value}`
    : `predefined-${illness.value}`;
};

export const PREDEFINED_CHRONIC_ILLNESSES = CHRONIC_ILLNESSES.map((illness) =>
  createPredefined(illness),
);
